import { COLOR, line } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'HT_SINE',
  version: 1,
  label: 'Hilbert Sine Wave',
  pane: 'sub',
  category: 'cycles',
  series: 'normal',
  precision: 3,
  order: 60,
  inputs: [],
  outputs: [line('sine', 'Sine', COLOR.blue), line('leadsine', 'Lead sine', COLOR.orange)],
  talib: { functions: ['HT_SINE'], expr: 'HT_SINE(close)', outputs: { sine: 'sine', leadsine: 'leadsine' } },
  listed: true,
  tailSafe: true,
  // TA_HT_SINE_Lookback: 32 for the Hilbert engine + 31 "to be compatible with Tradestation".
  lookback: () => 63,
}
export default def
